import axios from 'axios'
import { getAccessToken, refreshAccessToken, forceLogout } from '@/contexts/AuthContext'
import { API_BASE } from './config'
import { registerSessionBaggage } from './sessionBaggage'

export { API_BASE } from './config'

/** Wire shapes this client can decode that older shipped clients cannot.
 *
 *  The backend defaults to the OLD shape and upgrades only for a caller that
 *  declares support, because shipped iOS builds fail a whole response on one
 *  unknown enum value. Sending nothing is the safe state, so this header is the
 *  webapp opting in — not the backend sniffing versions. Add a capability here
 *  only once this client genuinely handles it. */
export const CLIENT_CAPABILITIES = 'laps'

export const apiClient = axios.create({
  baseURL: `${API_BASE}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'X-Beoflow-Client-Caps': CLIENT_CAPABILITIES,
  },
})

registerSessionBaggage(apiClient)

// Add JWT token to requests
apiClient.interceptors.request.use(config => {
  const token = getAccessToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle token refresh on 401
apiClient.interceptors.response.use(
  response => response,
  async error => {
    const token = getAccessToken()
    if (error.response?.status === 401 && token && !error.config._retried) {
      error.config._retried = true
      try {
        const newToken = await refreshAccessToken()
        error.config.headers.Authorization = `Bearer ${newToken}`
        return axios(error.config)
      } catch {
        forceLogout('api_401_refresh_failed')
      }
    }
    return Promise.reject(error)
  }
)
